function none() {}

export default {
	label: "None",
	effect: none,
	options: {},
};
